import { FormatterType } from '@components/Table/types';
import { useAvContext } from '../../../context/AvContextProvider';
import { useMeasurementsList } from '../../Reports/hooks';
import { FieldType } from '../../Sources/Mapping/types';
import { getFieldType } from '../getFieldType';

export const useGetFieldType = (activeProjName: string) => {
  const { fieldTypeMap, aggProjs } = useAvContext().accountEntities;
  const { name: entityName } = aggProjs[activeProjName]?.entityTypeId ?? {};
  const { data: measurements = [] } = useMeasurementsList({
    entityName,
    filterFunc: v => v.context.includes(entityName),
  });

  return ({ entityFieldKey }: { entityFieldKey: string }): FormatterType | typeof FieldType.FIX | undefined =>
    getFieldType({ entityFieldKey, measurements, fieldTypeMap });
};
